import { ConceptContent } from "../types";

export function markAnswer(content: ConceptContent): void {}
